<template>
  <div>
    <!--search form-->
    <el-form
      :inline="true"
      :model="searchForm"
      class="demo-form-inline"
      size="mini"
    >
      <el-form-item label="权益卡名称">
        <el-input v-model="searchForm.name" clearable></el-input>
      </el-form-item>
      <el-form-item label="权益卡类型">
        <el-select v-model="searchForm.type" placeholder="请选择" clearable>
          <el-option
            v-for="item in cardTypeOptions"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select>
      </el-form-item>

      <el-form-item label="状态">
        <el-select v-model="searchForm.status" placeholder="请选择" clearable>
          <el-option
            v-for="item in statusOptions"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="创建时间">
        <el-date-picker
          v-model="searchForm.beginTime"
          type="date"
          placeholder="选择日期"
          style="width:150px"
          value-format="yyyy-MM-dd"
        >
        </el-date-picker>
        ~
        <el-date-picker
          v-model="searchForm.endTime"
          type="date"
          placeholder="选择日期"
          style="width:150px"
          value-format="yyyy-MM-dd"
        >
        </el-date-picker>
      </el-form-item>

      <el-form-item>
        <el-button type="primary" @click="loadPage(1)">查询</el-button>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="handleAdd">新增</el-button>
      </el-form-item>
    </el-form>

    <!--buttons-->
    <div style="margin-bottom: 10px">
      <el-button size="mini" @click="gotoSubscriberPrivilege"
        >会员权益</el-button
      >
    </div>

    <el-table
      :data="tableData"
      style="width: 100%"
      border
      size="mini"
      v-loading="loading"
    >
      <el-table-column
        type="index"
        label="序号"
        width="50"
        align="center"
      ></el-table-column>
      <el-table-column
        prop="name"
        label="权益卡名称"
        align="center"
      ></el-table-column>
      <el-table-column prop="typeName" label="权益卡类型" align="center">
      </el-table-column>
      <el-table-column
        prop="price"
        label="权益卡价格"
        align="center"
      ></el-table-column>
      <el-table-column
        prop="discount"
        label="权益卡折扣"
        align="center"
      ></el-table-column>

      <el-table-column prop="validity" label="有效期/天" align="center">
      </el-table-column>
      <el-table-column prop="statusName" label="状态" align="center">
      </el-table-column>
      <el-table-column label="权益内容">
        <template slot-scope="scope">
          <el-tag
            v-for="item in scope.row.privilegesList"
            :key="item"
            size="mini"
            style="margin-right: 5px;"
            >{{ item | privilegeFilter(privilegeList) }}</el-tag
          >
        </template>
      </el-table-column>
      <el-table-column
        prop="created"
        label="创建时间"
        align="center"
      ></el-table-column>
      <el-table-column label="操作">
        <template slot-scope="scope">
          <el-link
            type="primary"
            :underline="false"
            size="mini"
            @click="handleEdit(scope.row)"
            >编辑</el-link
          >
          <el-divider direction="vertical"></el-divider>
          <el-link
            type="primary"
            :underline="false"
            size="mini"
            @click="grantPrivilege(scope.row)"
            >发放权益</el-link
          >
          <el-divider direction="vertical"></el-divider>
          <el-link
            type="primary"
            :underline="false"
            size="mini"
            @click="exchangeCodeRecord(scope.row)"
            >兑换记录</el-link
          >
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="searchForm.pageNum"
      :page-sizes="[10, 20, 50]"
      :page-size="searchForm.pageSize"
      layout="total, sizes, prev, pager, next, jumper"
      :total="searchForm.total"
    >
    </el-pagination>
    <biz-privilege-card-info
      ref="infoRef"
      @refresh="loadPage"
    ></biz-privilege-card-info>
    <grant-privilege-card
      ref="grantRef"
      @refresh="loadPage"
    ></grant-privilege-card>
    <exchange-code-record
      ref="exchangeCodeRef"
      @refresh="loadPage"
    ></exchange-code-record>
  </div>
</template>
<script>
import {
  privilegeCardTypeApi,
  privilegeCardStatusApi,
  bizPrivilegeCardPage,
  bizPrivilegePoolsList
} from "@/api/privilege";
import BizPrivilegeCardInfo from "./components/info.vue";
import GrantPrivilegeCard from "./components/grant.vue";
import ExchangeCodeRecord from "./components/exchangeCode.vue";
export default {
  filters: {
    privilegeFilter(value, privilegeList) {
      if (privilegeList && privilegeList.length > 0) {
        return privilegeList.find(item => item.id == value).name;
      }
      return value;
    }
  },
  components: {
    BizPrivilegeCardInfo,
    GrantPrivilegeCard,
    ExchangeCodeRecord
  },
  data() {
    return {
      searchForm: {
        pageNum: 1,
        pageSize: 10,
        total: 0
      },
      privilegeList: [],
      // 权益卡类型
      cardTypeOptions: [],
      // 权益卡状态
      statusOptions: [],
      tableData: [],
      loading: false
    };
  },
  created() {
    this.getPrivilegeCardTypeOptions();
    this.getPrivilegeCardStatusOptions();
  },
  mounted() {
    this.loadPrivilegeList();
    this.loadPage();
  },
  methods: {
    getPrivilegeCardTypeOptions() {
      let _self = this;
      privilegeCardTypeApi().then(resp => {
        if (resp.data.status == 100) {
          _self.cardTypeOptions = resp.data.results;
        }
      });
    },
    getPrivilegeCardStatusOptions() {
      let _self = this;
      privilegeCardStatusApi().then(resp => {
        if (resp.data.status == 100) {
          _self.statusOptions = resp.data.results;
        }
      });
    },
    loadPrivilegeList() {
      bizPrivilegePoolsList().then(resp => {
        if (resp.data.status == 100) {
          this.privilegeList = resp.data.results;
        }
      });
    },
    loadPage(page) {
      if (page) {
        this.searchForm.pageNum = page;
      }
      this.loading = true;
      bizPrivilegeCardPage(this.searchForm)
        .then(resp => {
          this.loading = false;
          if (resp.data.status == 100) {
            this.tableData = resp.data.results.list;
            this.searchForm.total = resp.data.results.total;
          } else {
            this.$message({
              message: resp.data.message,
              type: "error"
            });
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },
    handleSizeChange(pageSize) {
      this.searchForm.pageSize = pageSize;
      this.loadPage();
    },
    handleCurrentChange(page) {
      this.searchForm.pageNum = page;
      this.loadPage();
    },
    handleAdd() {
      const options = {
        statusOptions: this.statusOptions,
        cardTypeOptions: this.cardTypeOptions
      };
      this.$refs.infoRef.open(undefined, options);
    },
    handleEdit(row) {
      const options = {
        statusOptions: this.statusOptions,
        cardTypeOptions: this.cardTypeOptions
      };
      this.$refs.infoRef.open(row, options);
    },
    /**
     * 会员权益
     */
    gotoSubscriberPrivilege() {
      this.$router.push("/subscriberPrivilege");
    },
    /**
     * 发放权益
     * @param {Object} row
     */
    grantPrivilege(row) {
      this.$refs.grantRef.open(row);
    },
    /**
     *  兑换记录
     * @param {*} row
     */
    exchangeCodeRecord(row) {
      this.$refs.exchangeCodeRef.open(row);
    }
  }
};
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// index.vue?552ab981